import projectImage from "../afbeeldingen/ProjectRequrementAnalasys.png";
import devopsproject from "../afbeeldingen/devopsPoject.png";
import grafanpagina from "../afbeeldingen/grafanaPagina.png";
import grafanafilter from "../afbeeldingen/grafanafilter.png";
import grafanafilterDashboards from "../afbeeldingen/grafanafilteredDashboards.png";
import GrafanaOffcanvas from "../afbeeldingen/grafanaOffcanvas.png";
import grafanaNoDashboards from "../afbeeldingen/GrafanaNoDashboards.png";
import grafanaLogo from "../afbeeldingen/Grafana_logo.svg (1).png";
import translationsLogo from "../afbeeldingen/Google_Translate_logo.svg.png";
import vertalingtag from "../afbeeldingen/vertalingtag.png";
import dropdown from "../afbeeldingen/translationgmanagementdropdown.png";
import filteredtranslations from "../afbeeldingen/filteredtranslations.png";
import permissie1 from "../afbeeldingen/permissie1.png";
import permissie2 from "../afbeeldingen/permissie2.png";
import typetable from "../afbeeldingen/type table.png";
import aanpassentype from "../afbeeldingen/typeaanpassen.png";
import deletentype from "../afbeeldingen/typedeleten.png";
import toevoegentype from "../afbeeldingen/typetoevoegen.png";
import keytable from "../afbeeldingen/keytable.png";
import translationsoffcanvas from "../afbeeldingen/translationsoffcanvas.png";
import aangepastrecord from "../afbeeldingen/aangepasteoffcanvas.png";
import translationsoffcanvasaanpassen from "../afbeeldingen/aanpassenoffcanvas.png";
import dropdowntaal from "../afbeeldingen/taaldropdown.png";
import aangepastetaal from "../afbeeldingen/AangepasteTaal.png";
import aangepasteoffcanvastaal from "../afbeeldingen/aangepastetaaloffcanvas.png";
import WaterhubHome from "../afbeeldingen/WaterhubHome.png";
import WaterhubStationsDashboard from "../afbeeldingen/WaterhubStationDashboard.png";
import WaterhubAuthenticatie from "../afbeeldingen/WaterhubAuthenticatie.png";
import WaterhubStationVergelijken from "../afbeeldingen/WaterhubStationsVergelijken.png";
import WaterhubStationVergelijkenGrafiek from "../afbeeldingen/WaterhubStationsVergelijkenGrafiek.png";
import WaterhubStationToevoegen from "../afbeeldingen/WaterhubStationToevoegen.png";
import WaterhubMeting from "../afbeeldingen/WaterhubMeting.png";
import WaterhubGrafanaHome from "../afbeeldingen/WaterhubGrafanaHome.png";
import WaterhubGrafanaDropdown from "../afbeeldingen/WaterhubgGrafanaDropdown.png";
import WaterhubGrafanaProvincies from "../afbeeldingen/WaterhubGrafanaProvincies.png";
import WaterhubGrafanaProvinciesStad from "../afbeeldingen/WaterhubGrafanaProvincieStad.png";
import promotiefilmpje from "../afbeeldingen/promotiefilmpje.png";
const images = {
  projectImage,
  devopsproject,
  grafanpagina,
  grafanafilter,
  grafanafilterDashboards,
  GrafanaOffcanvas,
  grafanaNoDashboards,
  grafanaLogo,
  translationsLogo,
  vertalingtag,
  dropdown,
  filteredtranslations,
  permissie1,
  permissie2,
  typetable,
  aanpassentype,
  deletentype,
  toevoegentype,
  keytable,
  translationsoffcanvas,
  aangepastrecord,
  translationsoffcanvasaanpassen,
  dropdowntaal,
  aangepastetaal,
  aangepasteoffcanvastaal,
  WaterhubHome,
  WaterhubStationsDashboard,
  WaterhubAuthenticatie,
  WaterhubStationVergelijken,
  WaterhubStationVergelijkenGrafiek,
  WaterhubStationToevoegen,
  WaterhubMeting,
  WaterhubGrafanaHome,
  WaterhubGrafanaDropdown,
  WaterhubGrafanaProvincies,
  WaterhubGrafanaProvinciesStad,
  promotiefilmpje,
};

export default images;